// extracted by mini-css-extract-plugin
module.exports = {"honours":"honours_honours__4O69N","honours__header":"honours_honours__header__b8BDc","honours__name":"honours_honours__name__vUtDF","honours__list":"honours_honours__list__h_FBC"};